import * as mls_rs_uniffi from './generated/mls_rs_uniffi';
import initAsync from './generated/wasm-bindgen';

/// [CHANED]
// import wasmPath from './generated/wasm-bindgen/index_bg.wasm';
// Generated by uniffi-bindgen-react-native
// Export the generated bindings to the app.
export * from './generated/mls_rs_uniffi';

let isInitialised = false;

export async function uniffiInitAsync(): Promise<void> {
  if (isInitialised) {
    return;
  }

  try {
    await initAsync({ module_or_path: '/index_bg.wasm' });
  } catch (error) {
    console.error(error);
  }

  // Initialize the generated bindings: mostly checksums, but also callbacks.
  // - the boolean flag ensures this loads exactly once, even if the JS code
  //   is reloaded (e.g. during development with metro).
  mls_rs_uniffi.default.initialize();
  isInitialised = true;
}

// Export the crates as individually namespaced objects.
export default {
  mls_rs_uniffi,
};
